import script from "./ErrorsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorsView.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorsView.vue?vue&type=style&index=0&id=4e15b274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e15b274"]])

export default __exports__